export default __webpack_public_path__ + "static/media/38-HeightOfSummer.f08c5d31.jpeg";